import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'app-formly-field-help',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormlyModule
    ],
    template: `
            <div [class]="'helpvalue schema-form-helpvalue ' + props['htmlClass']" [innerHTML]="props['helpvalue']">
            </div>
  `
})
export class HelpFieldTypeComponent extends FieldType<FieldTypeConfig> { }
